import React from 'react';

import { useFreecodeContext } from 'hooks/useContext';
import FreecodeText from './FreecodeText';

export default function FreecodeSummary({ isCreator = false }) {
  const { testImpl } = useFreecodeContext();

  // TODO handle edit of text

  return <FreecodeText textContent={testImpl.description} isCreator={isCreator} />;
}
